import { render, staticRenderFns } from "./CommonSelectProject.vue?vue&type=template&id=a8072998"
import script from "./CommonSelectProject.vue?vue&type=script&lang=js"
export * from "./CommonSelectProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports